import { type GoogleSignInStatus, GoogleSignInStatusSchema } from '@sbc/domain-models/admin';
import { useQuery } from '@tanstack/react-query';

import { apiGet } from './client';

export function useGoogleSignInStatus() {
  return useQuery<GoogleSignInStatus>({
    queryKey: ['auth', 'google', 'status'],
    queryFn: () => apiGet('/api/auth/google/status', GoogleSignInStatusSchema),
    staleTime: Infinity,
  });
}
